export default "__VITE_ASSET__DzFlhr5K__"